
import {Component, Vue} from 'vue-property-decorator';
import {currentUserModule, exportsModule, studyModule} from "@/store";
import {MdbsCore} from "@/api/tsclient";
import DataExchangeTable from "@/components/exports/DataExchangeTable.vue";
import DataExchangeFileDto = MdbsCore.DataExchangeFileDto;
import Rights = MdbsCore.Rights;
import {startDownload} from "@/auxillary/export.helper";

@Component({
    components: {DataExchangeTable}
})
export default class QueriesExports extends Vue {

    async mounted() {
        if (this.canGetQueriesExportFiles) {
            await this.refreshQueriesExports();
        }

        if (this.canGetUserQueriesExportFiles) {
            await this.refreshUserQueriesExports();
        }

        if (this.canGetQueriesOverviewExportFiles) {
            await this.refreshQueriesOverviewExports();
        }
    }

    get loading() {
        return exportsModule.isLoading;
    }

    get canSeeQueriesExport() {
        return currentUserModule.hasRight(Rights.QueriesExportGetFilesCmd);
    }

    get canSeeUserQueriesExport() {
        return currentUserModule.hasRight(Rights.UserQueriesExportGetFilesCmd);
    }

    get canSeeQueriesOverviewExport() {
        return currentUserModule.hasRight(Rights.QueriesOverviewExportGetFilesCmd);
    }

    generateQueriesExport() {
        this.$emit('generate');
        exportsModule.generateQueriesExport({studyId: studyModule.study.id});
    }

    generateUserQueriesExport() {
        this.$emit('generate');
        exportsModule.generateUserQueriesExport({studyId: studyModule.study.id});
    }

    get queriesExportFiles() {
        return exportsModule.queriesExportsFiles;
    }

    get userQueriesExportFiles() {
        return exportsModule.userQueriesExportsFiles;
    }

    get queriesOverviewExportFiles() {
        return exportsModule.queriesOverviewExportsFiles;
    }

    async refreshQueriesExports() {
        await exportsModule.getQueriesExportsFiles({fromDate: undefined});
    }

    async refreshUserQueriesExports() {
        await exportsModule.getUserQueriesExportsFiles({fromDate: undefined});
    }

    async refreshQueriesOverviewExports() {
        await exportsModule.getQueriesOverviewExportsFiles({fromDate: undefined});
    }

    async downloadQueriesExport(item: DataExchangeFileDto) {
        const {fileName} = item;

        await exportsModule.downloadQueriesExport({fileName: fileName!})
            .then(response => {
                if (response) {
                    startDownload(response.data, fileName!);
                }
            }).catch(console.error)
    }

    async downloadUserQueriesExport(item: DataExchangeFileDto) {
        const {fileName} = item;

        await exportsModule.downloadUserQueriesExport({fileName: fileName!})
            .then(response => {
                if (response) {
                    startDownload(response.data, fileName!);
                }
            }).catch(console.error)
    }

    async downloadQueriesOverviewExport(item: DataExchangeFileDto) {
        const {fileName} = item;

        await exportsModule.downloadQueriesOverviewExport({fileName: fileName!})
            .then(response => {
                if (response) {
                    startDownload(response.data, fileName!);
                }
            }).catch(console.error)
    }

    get canGenerateQueriesExport() {
        return currentUserModule.hasRight(Rights.QueriesExportGetCmd);
    }

    get canGenerateUserQueriesExport() {
        return currentUserModule.hasRight(Rights.QueriesExportGetCmd);
    }

    get canGetQueriesExportFiles() {
        return currentUserModule.hasRight(Rights.QueriesExportGetFilesCmd);
    }

    get canGetUserQueriesExportFiles() {
        return currentUserModule.hasRight(Rights.UserQueriesExportGetFilesCmd);
    }

    get canGetQueriesOverviewExportFiles() {
        return currentUserModule.hasRight(Rights.QueriesOverviewExportGetFilesCmd);
    }

    get canDownloadQueriesExportFiles() {
        return currentUserModule.hasRight(Rights.QueriesExportGetFileCmd);
    }

    get canDownloadUserQueriesExportFiles() {
        return currentUserModule.hasRight(Rights.UserQueriesExportGetFileCmd);
    }

    get canDownloadQueriesOverviewExportFiles() {
        return currentUserModule.hasRight(Rights.QueriesOverviewExportGetFileCmd);
    }
}
